import {
  FETCH_SETTING_DETAIL,
  FETCH_SETTING_DETAIL_SUCCESS,
  FETCH_SETTING_DETAIL_FAILURE,
  UPDATE_SETTING_SUCCESS,
} from '../../actions/types';

const initialState = {
  settings: null,
  isLoading: false,
  error: null,
};

const settingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SETTING_DETAIL:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case FETCH_SETTING_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        settings: action.payload,
      };
    
    case UPDATE_SETTING_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.payload,
        },
      };

    case FETCH_SETTING_DETAIL_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default settingReducer;
